import * as actionTypes from './actionTypes';
import * as actionTypesSidebar from '@app/src/commons/sidebar/state/sidebar/actionTypes';

interface State {
  isFetching: boolean;
  errorMessage: string;
}

const initialState = {
  isFetching: false,
  errorMessage: ''
};

export const validateToken = (state: State = initialState, action): State => {
  switch(action.type) {
    case actionTypes.FETCH_VALIDATION_TOKEN_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case actionTypes.FETCH_VALIDATION_TOKEN_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.errorMessage,
      };
    case actionTypes.FETCH_VALIDATION_TOKEN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: '',
      };
    case actionTypesSidebar.RESET_APP_STATE:
      return initialState;
    default:
      return state;
  }
};
